import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { FormService } from '../form.service';
import { KRollService } from './kroll.service';
import { ShippingService } from './shipping.service';
@Injectable({
  providedIn: 'root'
})
export class AppService {
  constructor(
    public shippingService: ShippingService,
    public krollService: KRollService,
    private router: Router,
    private formService: FormService,
    private route: ActivatedRoute) {
  }
  getAppData(): Observable<any> {
    let deliveryPartner = this.shippingService.get_delivery_partner();
    let serverLocations = this.krollService.get_location();
    return forkJoin({ deliveryPartner: deliveryPartner, serverLocations: serverLocations });
  }

}
